import { Check, X } from 'lucide-react';
import { Badge } from '@reflex/ui/components/ui/badge';
import type { PluginSecretStatus } from '@/lib/plugin-registry';

export function SecretBadge({ secret }: { secret: PluginSecretStatus }) {
  if (secret.fulfilled) {
    return (
      <Badge variant="secondary" className="gap-1 text-xs font-normal text-status-success">
        <Check className="h-3 w-3" /> Set
      </Badge>
    );
  }
  return (
    <Badge variant="secondary" className="gap-1 text-xs font-normal text-status-accent-orange">
      <X className="h-3 w-3" /> Not set
    </Badge>
  );
}
